import { render } from "./BaseUserForm.vue?vue&type=template&id=6274e4bb&scoped=true"
import script from "./BaseUserForm.vue?vue&type=script&lang=ts"
export * from "./BaseUserForm.vue?vue&type=script&lang=ts"

import "./BaseUserForm.vue?vue&type=style&index=0&id=6274e4bb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6274e4bb"

export default script